/* eslint-disable no-alert */
/* eslint-disable react-hooks/exhaustive-deps */
// import { useCallback, useEffect, useState } from 'react';
// import { useRouter } from 'next/router';
// import { useBlocker } from './useBlocker';

// const checkIgnoreLocations = (location: { pathname: string | any[]; }, ignoreLocations: any[] | undefined) => {
//   if (ignoreLocations?.length === 0) return false;
//   return ignoreLocations?.every((e: any) => location?.pathname.includes(e));
// };

// // ignoreLocations la 1 mang key string
// export function useCallbackPrompt(when: boolean, ignoreLocations?: string[]) {
//   const navigate = useRouter();
//   const location = useRouter().query;
//   const [showPrompt, setShowPrompt] = useState(false);
//   const [lastLocation, setLastLocation] = useState<any>(null);
//   const [confirmedNavigation, setConfirmedNavigation] = useState(false);

//   const cancelNavigation = useCallback(() => {
//     setShowPrompt(false);
//   }, []);

//   // handle blocking when user click on another route prompt will be shown
//   const handleBlockedNavigation = useCallback(
//     (nextLocation: any) => {
//       console.log("nextLocation", nextLocation);
      
//       // in if condition we are checking next location and current location are equals or not      
//       if (!confirmedNavigation && nextLocation?.pathname !== location.pathname) {
//         if (checkIgnoreLocations(nextLocation, ignoreLocations)) {
//           setShowPrompt(false);
//           setConfirmedNavigation(true);
//         } else {
//           setShowPrompt(true);
//         }
//         setLastLocation(nextLocation);
//         return false;
//       }
//       return true;
//     },
//     [confirmedNavigation],
//   );

//   const confirmNavigation = useCallback(() => {
//     setShowPrompt(false);
//     setConfirmedNavigation(true);
//   }, []);

//   useEffect(() => {
//     if (confirmedNavigation && lastLocation) {
//       navigate.push(lastLocation.location.pathname);
//     }
//   }, [confirmedNavigation, lastLocation]);

//   useBlocker(handleBlockedNavigation, when);

//   return [showPrompt, confirmNavigation, cancelNavigation] as const;
// }

import { useEffect } from "react";
import Router from "next/router";
import { useBeforeUnload } from "react-use";

export const useLeavePageConfirm = (
  isConfirm = true,
  message = "Hệ thống sẽ không ghi nhận kết quả khi bạn chưa submit!"
) => {
  useBeforeUnload(isConfirm, message);
  useEffect(() => {
    const handler = () => {
      if (isConfirm && !window.confirm(message)) {
        const newLocal = "Route Canceled";
        throw newLocal;
      }
    };

    Router.events.on("routeChangeStart", handler);
    return () => {
      Router.events.off("routeChangeStart", handler);
    };
  }, [isConfirm, message]);
};